import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SelectItem } from 'primeng/components/common/selectitem';

import { environment } from '../../../environments/environment';
import { ITag } from './ITag';

@Injectable()
export class TagService {
  private baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) { }

  getTagSelectItems(tags: ITag[]): SelectItem[] {
    return tags.map(tag => <SelectItem>{label: tag.tagName, value: tag.tagId});
  }

  getSQFTags(): Observable<ITag[]> {
    return this.http.get<ITag[]>(`${this.baseUrl}/strategies/tags/?type=SQF`);
  }

  getAdEDTags(): Observable<ITag[]> {
    return this.http.get<ITag[]>(`${this.baseUrl}/strategies/tags/?type=AE`);
  }
}
